import type { RouteRecordRaw } from "vue-router";

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: "/reports",
    name: "downloadable-reports",
    component: () => import("../../views/reports/DownloadableReports.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/report/error",
    component: () => import("../../views/reports/MB2ErrorReport.vue"),
    meta: { requiresAuth: true, requiresStaff: true, pageHeader: "Error report" },
  },
  {
    path: "/pdf-report",
    name: "pdf-report",
    meta: { requiresAuth: true, noHeader: true, noMargin: true, noFooter: true, hideSidebar: true },
    component: () => import("../../views/PDF-report-templates/MimboxSavingsReport.vue"),
  },
];
